import { toast } from "react-toastify";

export const toastNetworkError = err => {
    let message = err?.response?.data?.message;
    Array.isArray(message) && (message = message[0]);
    message = message || 'Something went wrong. Please try again later.';
    toast.error(message, {
        autoClose: 5000,
    });
}